import * as Immutable from "immutable";

const initialState = Immutable.Map({
  untrainedExpressionChanged: false
});

/**
 * @param {Object} state
 * @param {Object} action
 * @returns {Object}
 */
export default function analyticsOverviewPage(state = initialState, action) {
  switch (action.type) {
    case "SET_UNTRAINED_EXPRESSION_CHANGED": {
      return state.set("untrainedExpressionChanged", action.value);
    }

    case "TRAIN_EXPRESSION_SUCCESS":
    case "TRAIN_EXPRESSIONS_SUCCESS":
      return state.set("untrainedExpressionChanged", true);

    case "UNDO_ACTIVITY_SUCCESS":

      if (
        (action.activity.get("activityType") === "update" ||
        action.activity.get("activityType") === "batch_update") &&
        action.activity.get("resourceType") === "expression"
      ) {
        return state.set("untrainedExpressionChanged", true);
      }

      return state;

    default: {
      return state;
    }
  }
}
